import { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "./ui/button";
import { Plus, Trash2 } from "lucide-react";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";

/** Je eigen afkortingen voor het zoeken. Post d, gbrain punt 75.
 *
 *  "EP" betekent "Export Partners": staat de afkorting als heel woord in een
 *  vraag, dan zoekt NovaMund ook op de voluit-vorm. Hoofdlettergevoelig. Het
 *  antwoord en het scherm zien gewoon je eigen vraag.
 *
 *  **FIX 8, FRANKS GLASRONDE VAN 11 OKTOBER 2026: DE + DEED NIETS.** In het log
 *  kwam geen enkele POST aan. De velden droegen als VOORBEELD precies "EP" en
 *  "Export Partners", de waarden uit de testlijst, dus zij zagen er ingevuld uit
 *  terwijl zij leeg waren; de knop stond stil uit en Enter deed daardoor ook
 *  niets. Nu: neutrale voorbeelden, een knop die altijd reageert, en een zin die
 *  zegt wat er ontbreekt of wat er is opgeslagen.
 */
export const LEEG = "Vul de afkorting en de voluit-vorm allebei in.";

export default function AliassenPaneel() {
  const { t } = useTaal();
  const [lijst, setLijst] = useState([]);
  const [kort, setKort] = useState("");
  const [voluit, setVoluit] = useState("");
  const [fout, setFout] = useState("");
  const [gelukt, setGelukt] = useState("");

  const haal = async () => {
    try {
      const r = await axios.get(`${API}/aliassen`);
      setLijst(Array.isArray(r.data) ? r.data : []);
    } catch (err) {
      setFout(err?.response?.data?.detail || t("De afkortingen konden niet worden opgehaald."));
    }
  };

  // Alleen bij het openen; `haal` meegeven zou hem bij elke render laten lopen.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { haal(); }, []);

  const voegToe = async (e) => {
    e.preventDefault();
    setFout("");
    setGelukt("");
    const k = kort.trim();
    const v = voluit.trim();
    if (!k || !v) {
      setFout(LEEG);
      return;
    }
    try {
      await axios.post(`${API}/aliassen`, { kort: k, voluit: v });
      setKort("");
      setVoluit("");
      setGelukt(`${k} zoekt nu ook op ${v}.`);
      await haal();
    } catch (err) {
      setFout(err?.response?.data?.detail || t("De afkorting is niet opgeslagen."));
    }
  };

  const haalWeg = async (id) => {
    try {
      await axios.delete(`${API}/aliassen/${id}`);
      await haal();
    } catch (err) {
      setFout(err?.response?.data?.detail || t("De afkorting is niet weggehaald."));
    }
  };

  return (
    <section className="space-y-2" data-testid="aliassen">
      <h2 className="text-xs font-medium uppercase tracking-wide text-muted-foreground px-1">{t("Afkortingen")}</h2>
      <p className="text-[11px] text-muted-foreground px-1">
        {t("Staat de afkorting in je vraag, dan zoekt NovaMund ook op de voluit-vorm. Bijvoorbeeld EP voor Export Partners.")}
      </p>
      <ul className="space-y-1">
        {lijst.map((a) => (
          <li key={a.id} className="flex items-center gap-2 text-xs px-1" data-testid="alias-rij">
            <span className="font-medium">{a.kort}</span>
            <span className="min-w-0 flex-1 truncate text-muted-foreground">{a.voluit}</span>
            <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => haalWeg(a.id)}
                    aria-label={`Haal ${a.kort} weg`} data-testid="alias-weg">
              <Trash2 className="h-3 w-3" />
            </Button>
          </li>
        ))}
      </ul>
      <form onSubmit={voegToe} className="flex gap-1">
        <input className="w-20 min-w-0 border rounded px-2 py-1 text-xs bg-background" placeholder={t("afkorting")}
               aria-label={t("Afkorting")} value={kort} onChange={(e) => setKort(e.target.value)}
               data-testid="alias-kort" />
        <input className="min-w-0 flex-1 border rounded px-2 py-1 text-xs bg-background"
               placeholder={t("voluit")} aria-label={t("Voluit")} value={voluit}
               onChange={(e) => setVoluit(e.target.value)} data-testid="alias-voluit" />
        <Button type="submit" variant="outline" size="icon" className="h-7 w-7 shrink-0"
                aria-label={t("Voeg afkorting toe")} data-testid="alias-toevoegen">
          <Plus className="h-3 w-3" />
        </Button>
      </form>
      {fout && <p className="text-[11px] text-[hsl(var(--destructive))] px-1" data-testid="alias-fout">{fout}</p>}
      {gelukt && <p className="text-[11px] text-muted-foreground px-1" data-testid="alias-gelukt">{gelukt}</p>}
    </section>
  );
}
